/** What each of the six census states does to a total, said once, beside the states' own words
 * (`sourceModel.STATE`). EmitIQ's own note, restated from the census's semantics: it states no
 * number, because what a gap costs in tonnes is not known (nothing arrived to price it). */
export const EFFECT: Readonly<Record<string, { word: string; tone: "ok" | "warn" | "neutral" }>> = {
  submitted: { word: "Counted in every total", tone: "ok" },
  declared_nil: { word: "Counted as nothing, on a person's statement", tone: "neutral" },
  missing: { word: "Not counted: absent from every total, not zero", tone: "warn" },
  pending: { word: "Not due yet: not counted either way", tone: "neutral" },
  unknown: { word: "Not counted: nothing may have happened, and EmitIQ cannot tell", tone: "neutral" },
  not_expected: { word: "Not expected in this period", tone: "neutral" },
};
